import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { tms } from "../tms";
import { IRequestOptions } from "../IRequestOptions";

/**
 * @description 会议用户信息
 */
export interface IMeetingUserInfo {
    user_id: string;
    display_name: string;
    avatar_url?: string;
}

/**
 * @description 紧急呼救事件类型
 */
export type EventType = 'medical' | 'security';

/**
 * @description 可参与的会议信息
 */
export interface IAvailableMeeting {
    event_uuid: string;
    short_code: string;
    role: 'initiator' | 'responder';
    status: string;
    created_at: number;
    initiator_info: IMeetingUserInfo;
    livekit_room_name: string;
    access_mode: string;
    event_type?: EventType;
}

/**
 * @description 获取可参与会议的请求参数
 */
export interface IEventCallListAvailableMeetingsParams extends IRequestParams {
    // 这个API不需要请求参数
}

/**
 * @description 获取可参与会议的响应结果
 */
export interface IEventCallListAvailableMeetingsResult extends IResultContent {
    data: {
        is_ok: boolean;
        msg: string;
        meetings: IAvailableMeeting[];
    };
}

/**
 * @description 获取用户可参与的音视频会议列表
 * @param opts 包含 params, gateway, handler 的请求选项
 */
export async function tmsEventCallListAvailableMeetings(opts: IRequestOptions<IEventCallListAvailableMeetingsParams>) {
    const res = await request<IEventCallListAvailableMeetingsResult>(
        tms.TEventCall, 
        tms.MEventCallListAvailableMeetings, 
        opts.params, 
        opts.gateway, 
        opts.handler
    );
    return res;
}